import styled from '@emotion/styled'

import { mq } from '../../constants/breakpoints'

export const CustomerList = styled.div`
  & > * {
    margin-bottom: 16px;
    display: block;
  }

  a {
    text-decoration: none;
  }

  button {
    float: right;
    margin-top: 1rem;

    svg {
      margin-right: 10px;
    }
  }
`

export const SearchContainer = styled.div`
  form {
    height: 40px;
    width: 280px;
    font-size: 0.8rem;

    ${mq.mobile} {
      margin-bottom: 1rem;
      width: 100%;
    }
  }
`

export const SortButton = styled.button`
  border: none;
  background: none;
  padding: none;
`
export const ListInfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  p {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 5px;
    vertical-align: bottom;
  }
`

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin: 15px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 1rem;

  ${mq.mobile} {
    display: inline-block;
    margin-top: 0;
  }

  h1 {
    ${mq.mobile} {
      margin-top: 0;
    }
  }
`

export const HeaderText = styled.h1`
  color: ${({ theme }) => theme.pageHeaderColor || 'black'};
  font-size: 2rem;
  font-weight: bold;
  min-height: 2rem;
  margin: 0;

  ${mq.mobile} {
    margin-bottom: 1rem;
    width: 100%;
  }
`
